import {Component, OnInit, NgModule} from '@angular/core';
import {Router, NavigationEnd, RouterModule} from '@angular/router';
import {CommonModule} from '@angular/common';

import {countryConfig} from 'src/country-config/country-config';
import {IconsModule} from '../icons/icons.module';
import {PrimeFlagModule} from '../navbar/prime-flag/prime-flag.module';
import { AlgoliaManager } from 'src/app/data/manager/algolia/algolia.manager';
import { ScrollEvent } from '../../event-listeners/scroll/scroll.event';
import { HeaderCategoriesInterface } from 'src/app/data/networking/models/categories/categories.interface';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})

export class HeaderComponent implements OnInit {
  itemsDeparments: any = []
  itemsMenu = [];
  itemsSubMenu = []
  departmentActive: any = {};
  categorieActive: any = {};
  showDeparments = false;
  showDeparmentsFrom = 'menu';
  colorHeader = '#418fde';
  showSubMenu = true;
  showListCategories = false;
  showListSubCategories = false;
  showListBrands = false;
  countryConfig = countryConfig;
  primeActive: any = {};
  primeConfig: any = {};
  hideMenuScroll = false;
  scrollTop = 0;

  constructor(private router: Router, private algoliaManager: AlgoliaManager, private scrollEvent: ScrollEvent) {}

  clearSelects() {
    this.showListCategories = false;
    this.showListBrands = false;
    this.showListSubCategories = false;
    this.departmentActive = {};
    this.categorieActive = {};
    this.itemsDeparments.map(deparment => deparment.active = false );
  }

  handleDeparments(option, item?) {

    this.clearSelects();

    if (option === 'subMenu') {
      this.showDeparments = true;
      this.activeDeparment(item);
    } else if (option === 'menu' && this.showDeparmentsFrom === 'subMenu') {
      this.showDeparments = true;
    } else {
      this.showDeparments = !this.showDeparments;
    }
    this.showDeparmentsFrom = option;
  }

  activeDeparment(option: any) {
    this.itemsDeparments.map(deparment => {
      deparment.categories.map(elementSub => elementSub.active = false);
      if (option.id === deparment.id) {
        this.departmentActive = deparment;
        deparment.active = true;
        this.showListCategories = true;
        this.showListBrands = this.departmentActive.brandRecommended ? true : false;
        this.showListSubCategories = false;
      } else {
        deparment.active = false;
      }
    });
  }

  activeCategorie(option: any): void {
    this.departmentActive.categories.forEach(deparment => {
      if (option.id === deparment.id) {
        this.categorieActive = deparment;
        deparment.active = true;
        this.showListSubCategories = true;
      } else {
        deparment.active = false;
      }
    });
  }

  validateRoute() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.showDeparments = false;

        this.validateShowSubMenu(event.url);

        if (event.url.includes('/categorias')) {
          const auxPath = `/categorias/${event.url.split('/')[2]}`;
          const auxColor = this.itemsDeparments.find(deparment => deparment.path === auxPath);
          this.colorHeader = auxColor === undefined ? '#418fde' : auxColor.color;
        } else {
          this.colorHeader = '#418fde';
        }
      }
      


    });
  }

  setData(data) {
    this.itemsDeparments = data.itemsDepartments;
    this.itemsMenu = data.itemsMenu;
    this.itemsSubMenu = data.itemsSubMenu;
  }

  toggleMenuScroll() {
    this.scrollEvent.scrollWindow.subscribe((event) => {
      if (event > 40) {
        this.hideMenuScroll = true;
      } else if (event < 20) {
        this.hideMenuScroll = false;
      }

      if ( this.scrollTop > event) {
          this.hideMenuScroll = false;
      }

      this.scrollTop = event;
    });
  }

  validateShowSubMenu( url: string ) {
    if (url === '/' && this.itemsSubMenu.length > 0) {
      this.showSubMenu = true;
    } else {
      this.showSubMenu = false;
    }

  }

  ngOnInit(): void {
    if (sessionStorage.getItem('dataDeparments')) {
      const newDataDeparments = JSON.parse(sessionStorage.getItem('dataDeparments'));
      this.setData(newDataDeparments);
      this.validateRoute();
    } else {
      this.algoliaManager.getPropertiesFromPostgres('CATEGORIES.CONFIG.V2')
        .then( (categories: HeaderCategoriesInterface| Object) => {
          sessionStorage.setItem('dataDeparments', JSON.stringify(categories));
          this.setData(categories);
          this.validateRoute();
        })
    }

  this.toggleMenuScroll();
  }
}

@NgModule({
  declarations: [HeaderComponent],
  exports: [HeaderComponent],
  imports: [CommonModule,RouterModule, IconsModule, PrimeFlagModule],
})
export class HeaderModule { }
